import { request } from "@/store";
import moment from "moment";
var _ = require("lodash");
const ppcSbSettings = {
  state: {
    currentWeek: moment().startOf("isoWeek"),
    strategies: [],
    weekFilled: [],
    weeksRange: []
  },
  getters: {
    ppcSbSettingsWeeksGet(state) {
      return () => {
        return state.weeksRange.map(weekData => weekData.week);
      };
    }
  },
  mutations: {
    ppcSbSettingsStrategiesSet(state, payload) {
      state.strategies = payload;
    },
    ppcSbSettingsWeekFilled(state, payload) {
      state.weekFilled = payload;
    },
    ppcSbSettingsWeeksRangeSet(state, payload) {
      state.weeksRange = payload;
    },
    ppcSbBudgetStrategySet(state, payload) {
      state.weeksRange = state.weeksRange.map(item => {
        let budget_strategy_items = payload.find(budget_strategy => budget_strategy.week === item.week);
        return {
          ..._.mergeWith({}, item, budget_strategy_items, (o, s) => _.isNull(s) ? o : s)
        };
      });
    },
    ppcSbSettingsStoreClear(state) {
      state.strategies = [];
      state.weekFilled = [];
      state.weeksRange = [];
    }
  },
  actions: {
    async ppcSbBudgetStrategy({
      commit
    }, payload) {
      let result = (await request("/ppc/settings/sb_budget_strategy/get", "POST", payload)) ?? {
        data: []
      };
      if (result.data) {
        commit("ppcSbBudgetStrategySet", result.data);
      }
      return result;
    },
    async ppcSbBudgetStrategyFromBQ({
      commit
    }, payload) {
      let result = (await request("/ppc/settings/sb_budget_strategy/get_from_bq", "POST", payload)) ?? {
        data: []
      };
      if (result.data) {
        commit("ppcSbBudgetStrategySet", result.data);
      }
      return result;
    },
    async ppcSbStrategiesSave(_, payload) {
      let result = (await request("/ppc/settings/sb_budget_strategy/create", "POST", payload)).data;
      return result;
    },
    async ppcSbBudgetDelete(_, payload) {
      await request("/ppc/settings/sb_budget_strategy/delete", "POST", payload);
    },
    ppcSbSettingsClearStrategies({
      commit
    }) {
      commit("ppcSbSettingsStrategiesSet", []);
      commit("ppcSbSettingsWeekFilled", []);
    },
    ppcSbSettingsClearStore({
      commit
    }) {
      commit("ppcSbSettingsStoreClear");
    }
  }
};
export default ppcSbSettings;